import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { tiltControls } from '@shared/constants/CommandValues';
import { createUUID } from '@shared/constants/Keys';
import { CommonResourceKey } from '@shared/models/ResourceKeys';
import { IControlFieldProps } from '@shared/models/components/IControlFieldProps';
import { useTranslation } from 'react-i18next';

function TiltControlField({ value, onChange, disabled }: IControlFieldProps) {
    const { t } = useTranslation();
    const fieldId = createUUID();
    disabled = true;
    return (
        <FormControl fullWidth>
            <InputLabel id={fieldId}>
                {t('common:motion.title')} - {t('common:deprecated')}
            </InputLabel>
            <Select
                disabled={disabled}
                labelId={fieldId}
                value={value}
                label={t('common:motion.title')}
                onChange={(e) => onChange(e.target.value)}>
                {tiltControls.map((c) => (
                    <MenuItem key={c.value} value={c.value}>
                        {t(c.title as CommonResourceKey)}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}

export default TiltControlField;
